"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * zwraca minimalną wartość
 * @param values tablica wartości
 */
function min(values) {
    var result = values[0];
    var i = values.length;
    while (--i > 0) {
        if (values[i] < result) {
            result = values[i];
        }
    }
    return result;
}
exports.default = min;
//# sourceMappingURL=min.js.map